import { useEffect } from "react";

const TermsOfService = () => {
  useEffect(() => {
    document.title = "Terms of Service | TaleCraft";
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow overflow-hidden rounded-lg">
          <div className="px-4 py-5 sm:px-6">
            <h1 className="text-3xl font-bold text-gray-900">Terms of Service</h1>
            <p className="mt-1 text-sm text-gray-500">Effective Date: April 1, 2025</p>
          </div>
          <div className="border-t border-gray-200 px-4 py-5 sm:p-6 prose max-w-none text-gray-900">
            <section>
              <h2 className="text-xl font-bold mb-2 text-gray-900">1. Acceptance of Terms</h2>
              <p className="mb-4 text-gray-900">By using TaleCraft, you agree to these Terms of Service. If you do not agree, please discontinue using the platform.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-2 text-gray-900">2. Account & Eligibility</h2>
              <ul className="list-disc pl-6 mb-4 text-gray-900">
                <li>You must be at least <strong>13 years old</strong> (or in compliance with local laws regarding minimum age).</li>
                <li>You are responsible for maintaining the security of your <strong>account credentials</strong>.</li>
                <li>Any activity under your account is your responsibility.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-2 text-gray-900">3. User-Generated Content</h2>
              <ul className="list-disc pl-6 mb-4 text-gray-900">
                <li>Users retain full ownership of their <strong>stories and creative content</strong> created within TaleCraft.</li>
                <li>TaleCraft may feature <strong>publicly shared</strong> stories for platform promotion.</li>
                <li>The platform does not <strong>moderate or validate</strong> user-generated content but reserves the right to remove harmful or inappropriate material.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-2 text-gray-900">4. Issue Reporting & Support</h2>
              <ul className="list-disc pl-6 mb-4 text-gray-900">
                <li>Users can <strong>report technical issues and platform concerns</strong> via a built-in form-based system.</li>
                <li>TaleCraft does not provide AI-driven chat support but processes user issues manually.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-2 text-gray-900">5. Data Storage & Processing</h2>
              <ul className="list-disc pl-6 mb-4 text-gray-900">
                <li>AI-related data is <strong>not stored locally</strong> but may be processed using <strong>Supabase</strong>.</li>
                <li>TaleCraft does not <strong>store or track AI processing data</strong> beyond what is necessary for improving user experience.</li>
                <li>Personal data handling complies with <strong>applicable privacy regulations</strong> (see Privacy Policy).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-2 text-gray-900">6. Acceptable Use Policy</h2>
              <p className="mb-2 text-gray-900">Users agree <strong>NOT</strong> to:</p>
              <ul className="list-disc pl-6 mb-4 text-gray-900">
                <li>Post or share <strong>illegal, hateful, or explicit content</strong>.</li>
                <li>Use the platform for <strong>fraudulent, deceptive, or misleading</strong> activities.</li>
                <li>Attempt to <strong>hack, scrape, or overload</strong> TaleCraft's services.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-2 text-gray-900">7. Paid Features, Free Tier & Advertising</h2>
              <ul className="list-disc pl-6 mb-4 text-gray-900">
                <li>TaleCraft offers various subscription tiers, including a free tier with limited features.</li>
                <li>Users on the <strong>free subscription tier</strong> will be shown <strong>advertisements</strong> while using the service.</li>
                <li>These advertisements are provided through <strong>Google AdSense</strong> and are subject to Google's advertising policies.</li>
                <li>Premium subscriptions (Basic and Premium tiers) offer an <strong>ad-free experience</strong> along with additional features.</li>
                <li>Refund requests for paid subscriptions are handled on a <strong>case-by-case basis</strong>, depending on service usage and issues encountered.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-2 text-gray-900">8. Advertising Content</h2>
              <ul className="list-disc pl-6 mb-4 text-gray-900">
                <li>Advertisements displayed on TaleCraft are provided by third-party advertisers through Google AdSense.</li>
                <li>TaleCraft does not endorse products or services advertised on our platform.</li>
                <li>We strive to ensure advertisements are appropriate, but cannot guarantee the content of all ads.</li>
                <li>Users who encounter inappropriate advertisements are encouraged to report them to us.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-2 text-gray-900">9. Liability Disclaimer</h2>
              <ul className="list-disc pl-6 mb-4 text-gray-900">
                <li>TaleCraft is provided <strong>"as is"</strong> without any warranties.</li>
                <li>We do not guarantee the <strong>accuracy, reliability, or availability</strong> of generated content.</li>
                <li>Users are responsible for ensuring their content complies with legal requirements.</li>
                <li>We are not responsible for the content of advertisements displayed via third-party services like Google AdSense.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-2 text-gray-900">10. Termination & Policy Updates</h2>
              <ul className="list-disc pl-6 mb-4 text-gray-900">
                <li>We reserve the right to <strong>suspend or terminate accounts</strong> that violate these terms.</li>
                <li>These Terms of Service may be updated periodically. Continued use of TaleCraft after changes means you accept the new terms.</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
